import { render, staticRenderFns } from "./NovelGroupDeleteConfirmDialog.vue?vue&type=template&id=733171eb&scoped=true"
import script from "./NovelGroupDeleteConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./NovelGroupDeleteConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./NovelGroupDeleteConfirmDialog.vue?vue&type=style&index=0&id=733171eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733171eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733171eb')) {
      api.createRecord('733171eb', component.options)
    } else {
      api.reload('733171eb', component.options)
    }
    module.hot.accept("./NovelGroupDeleteConfirmDialog.vue?vue&type=template&id=733171eb&scoped=true", function () {
      api.rerender('733171eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/NovelGroupDeleteConfirmDialog.vue"
export default component.exports